// Reads the platform and id from a YouTube or Vimeo watch URL

export const getVideoSource = (url) => {
  const youtubeId = url.match(/youtube\.com\/watch\?v=([\w-]{11})/)?.[1];
  if (youtubeId) return {youtubeId};
  return {vimeoId: url.match(/vimeo\.com\/(\d+)/)?.[1]};
};

export const getVideoId = (url) => {
  const {youtubeId, vimeoId} = getVideoSource(url);
  return youtubeId ?? vimeoId;
};
